import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=fe787c78&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=fe787c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe787c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe787c78')) {
      api.createRecord('fe787c78', component.options)
    } else {
      api.reload('fe787c78', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=fe787c78&scoped=true&", function () {
      api.rerender('fe787c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/saleSet/index.page.vue"
export default component.exports